module.exports = __webpack_public_path__ + "static/img/green_01_514.3283ca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/deco/green_01_514.png
// module id = 2e47
// module chunks = 0